import React from 'react';
import {FieldArray, useFormikContext} from "formik";
import {Button, Grid} from '@material-ui/core';
import {Dropzone, MIME_TYPES} from "@mantine/dropzone";
import {IconPhoto, IconUpload, IconX} from "@tabler/icons";
import {Group, Text} from "@mantine/core";
import Thumb from "../../../../../Thumb";
import ClearIcon from "@material-ui/icons/Clear";
import MantineSelectField from "../../../../FormikUtils/MantineSelectField";
import MantineNumberField from "../../../../FormikUtils/MantineNumberField";

export default function EmpleoForm(props) {
    const {
        formField: {condicionLaboral, montoBruto},
    } = props;
    const {setFieldValue, values} = useFormikContext();

    const condicionLaboralOptions = [
        {value: '0', label: 'Empleado'},
        {value: '1', label: 'Autónomo'},
    ];

    return (
        <React.Fragment>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <MantineSelectField
                        name={condicionLaboral.name}
                        label={condicionLaboral.label}
                        data={condicionLaboralOptions}
                        withAsterisk
                    />
                </Grid>
                {values.condicionLaboral === "0" &&

                    <>
                        <Grid item xs={12} sm={6}>
                            <MantineNumberField
                                name={montoBruto.name}
                                label={montoBruto.label}
                                styles={{input: {textAlign: "right"}}}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} style={{paddingTop: '32px'}}>
                            <Dropzone

                                style={values.archivos.length >= 1 ? {
                                    backgroundColor: "#f8f9fa",
                                    borderColor: "#f8f9fa",
                                    cursor: 'not-allowed',

                                    '& *': {
                                        color: "#adb5bd",
                                    }
                                } : {}}


                                onDrop={(files) => {
                                    let json = []
                                    let len = values.archivos.length
                                    files.map(async function (file) {
                                        if (len < 1) {
                                            json.push({
                                                "name": file.name,
                                                "content": "",
                                                "filetype": file.type,
                                                "file": file
                                            })
                                        }
                                        len += 1
                                    })
                                    setFieldValue('archivos', values.archivos.concat(json));
                                }}
                                onReject={(files) => console.log('rejected files', files)}
                                maxSize={3 * 1024 ** 2}
                                maxFiles={1}
                                accept={[MIME_TYPES.png, MIME_TYPES.jpeg, MIME_TYPES.pdf]}
                                disabled={values.archivos.length >= 1}
                                {...props}
                            >
                                <Group position="center" spacing="xl" style={{minHeight: 220, pointerEvents: 'none'}}>
                                    <Dropzone.Accept>
                                        <IconUpload
                                            size={50}
                                            stroke={1.5}
                                        />
                                    </Dropzone.Accept>
                                    <Dropzone.Reject>
                                        <IconX
                                            size={50}
                                            stroke={1.5}
                                            // color={theme.colors.red[theme.colorScheme === 'dark' ? 4 : 6]}
                                        />
                                    </Dropzone.Reject>
                                    <Dropzone.Idle>
                                        <IconPhoto size={50} stroke={1.5}/>
                                    </Dropzone.Idle>

                                    <div>
                                        <Text size="xl" inline align="center">
                                            Arrastre o haga clic para seleccionar los archivos
                                        </Text>
                                        <Text size="sm" color="dimmed" inline mt={7}>
                                            Adjuntar un solo archivo (imágen o PDF), no puede superar los 5mb.
                                        </Text>
                                    </div>
                                </Group>

                            </Dropzone>

                        </Grid>
                        <FieldArray name='archivos'>{({remove}) => (
                            values.archivos.map((file, index) => {
                                return (
                                    <Grid item xs={6} sm={4}>
                                        <Thumb index={index} values={values} file={file.file} product={'PREVENCION'}/>
                                        <Button onClick={() => remove(index)}><ClearIcon/></Button>
                                    </Grid>
                                )
                            })
                        )}</FieldArray>
                    </>

                }

            </Grid>
        </React.Fragment>
    );
}
